import { get } from "@ember/object"
import { alias } from "@ember/object/computed"
import Service, { inject as service } from "@ember/service"
import _ from "lodash"

export default class AppState extends Service {
  @service dispatcher

  @service session

  @alias("session.id") id

  subscribeToChannel() {
    super.subscribeToChannel(...arguments)
    get(this, "dispatcher").subscribeToChannel("app-state", get(this, "session.id"))
  }

  dispatchToStore(component, type, payload) {
    get(this, "dispatcher").dispatch(
      type,
      _.merge(payload, {
        sessionId: get(this, "id"),
        componentId: get(component, "componentId"),
      })
    )
  }
}
